import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';
import { useForm } from 'react-hook-form';
import whatsappUtils from 'api/whatsapp-utils';
import { useNotifyAlert } from 'context/NotifyAlert';
const NewUserModal = ( {
	onClose,
	position,
	modalRef,
	addUser,
	userToEdit,
	handleSetUserToEdit
} ) => {
	const [ profileTypes, setProfileTypes ] = useState( [ { id: 0, name: 'Selecione um perfil' } ] );
	const [ departments, setDepartments ] = useState( [ { id: 0, name: 'Selecione um departamento' } ] );
	const [ userErrors, setUserErrors ] = useState( [] );
	const { register, handleSubmit, setValue } = useForm();
	const { setShowNotify } = useNotifyAlert();
	const handleSubmitForm = async ( data ) => {
		if( userToEdit ) {
			try {
				const userUpdated = await whatsappUtils
					.updateUser( {
						id            : userToEdit.id,
						name          : data.name,
						email         : data.email,
						profileTypeId : data.profileTypeId,
						departmentId  : data.departmentId
					} );
				addUser( userUpdated );
				setShowNotify( {
					status : 'success',
					text   : 'Usuário atualizado com sucesso!'
				} );
				handleCloseModal();
			} catch( error ) {
				setUserErrors( [ error?.response?.data?.message ?? 'Erro ao atualizar usuário' ] );
			}
			return;
		}
		const newUser = await whatsappUtils.createUser( {
			users: [
				{ ...data,
					profileTypeId : parseInt( data.profileTypeId ),
					departmentId  : parseInt( data.departmentId )
				} ] } );
		if( newUser.errors.length > 0 ) {
			setUserErrors( newUser.errors[ 0 ].errors );
			setShowNotify( {
				status : 'error',
				text   : 'Erro ao criar usuário'
			} );
			return;
		}
		if( newUser.newUsers.length > 0 ) {
			addUser( newUser.newUsers[ 0 ] );
			setShowNotify( {
				status : 'success',
				text   : 'Usuário criado com sucesso!'
			} );
			handleCloseModal();
			return;
		}
	};

	const handleFetchOptions = async () => {
		const [ profileTypes, departments ] = await Promise.all( [
			whatsappUtils.listProfileTypes(),
			whatsappUtils.listDepartments()
		] );
		setProfileTypes( [ { id: 0, name: 'Selecione um perfil' }, ...profileTypes ] );
		setDepartments( [ { id: 0, name: 'Selecione um departamento' }, ...departments ] );
	};

	useEffect( () => {
		handleFetchOptions();
	}, [] );

	useEffect( () => {
		if( userToEdit ) {
			setValue( 'name', userToEdit.name );
			setValue( 'email', userToEdit.email );
			setValue( 'profileTypeId', userToEdit.profileTypeId );
			setValue( 'departmentId', userToEdit.departmentId );
		}
	}, [ userToEdit, setValue ] );

	const handleCloseModal = () => {
		setValue( 'name', '' );
		setValue( 'email', '' );
		setValue( 'profileTypeId', 0 );
		setValue( 'departmentId', 0 );
		handleSetUserToEdit( null );
		onClose();
	};

	return (
		<S.ModalContainer position={position} ref={modalRef}>
			<S.ModalTitle>{userToEdit ? 'Editar Usuário' : 'Novo Usuário'}</S.ModalTitle>
			<S.ModalLabel htmlFor="name">Nome do Usuário
				<S.ModalInput type="text" placeholder="Insira o nome do usuário" {...register( 'name' )} />
			</S.ModalLabel>
			<S.ModalLabel htmlFor="email">Email do Usuário
				<S.ModalInput disabled={userToEdit} type="text" placeholder="Insira o email do usuário" {...register( 'email' )} />
			</S.ModalLabel>
			<S.ModalLabel htmlFor="profileTypeId">Perfil do Usuário
				<S.ModalSelect {...register( 'profileTypeId' )} defaultValue={userToEdit?.profileTypeId}>
					{profileTypes.map( ( profileType ) => (
						<option key={profileType.id} value={profileType.id} selected={profileType.id === userToEdit?.profileTypeId}>
							{profileType.name}
						</option>
					) )}
				</S.ModalSelect>
			</S.ModalLabel>
			<S.ModalLabel htmlFor="departmentId">Departamento do Usuário
				<S.ModalSelect {...register( 'departmentId' )} defaultValue={userToEdit?.departmentId}>
					{departments.map( ( department ) => (
						<option key={department.id} value={department.id} selected={department.id === userToEdit?.departmentId}>
							{department.name}
						</option>
					) )}
				</S.ModalSelect>
			</S.ModalLabel>
			<S.ModalError>
				{userErrors.length > 0 && userErrors.map( ( error ) => <S.ModalErrorItem key={error}>{error}</S.ModalErrorItem> )}
			</S.ModalError>
			<S.ModalButtons>
				<S.CancelButton onClick={handleCloseModal}>Cancelar</S.CancelButton>
				<S.SaveButton onClick={handleSubmit( handleSubmitForm )}> {userToEdit ? 'Editar' : 'Criar'}</S.SaveButton>
			</S.ModalButtons>
		</S.ModalContainer>
	);
};

NewUserModal.propTypes = {
	onClose  : PropTypes.func.isRequired,
	position : PropTypes.shape( {
		top  : PropTypes.number.isRequired,
		left : PropTypes.number.isRequired
	} ).isRequired,
	modalRef      : PropTypes.object.isRequired,
	addDepartment : PropTypes.func.isRequired
};

export default NewUserModal;
